import gql from 'graphql-tag';

const UPDATE_NEXT_ORDER_DATE = gql`
  mutation updateNextOrderDate($nextOrderDate: String!) {
    updateNextOrderDate(nextOrderDate: $nextOrderDate)
  }
`;

export {UPDATE_NEXT_ORDER_DATE};
